document.addEventListener("DOMContentLoaded", () => {
  const isMobile = window.innerWidth <= 768;

  const storySection = document.querySelector("#story");

  const storySection2 = document.querySelector(".story-section");
  const storyList = document.querySelector(".story-text-list");

  const storyContainer = document.querySelector(".story-content-2");
  const texts = [...document.querySelectorAll(".story-item-text")];
  const images = [...document.querySelectorAll(".story-main-image")];
  const numberEl = document.querySelector(".indicator-number");

  let currentIndex = 0;
  let isLocked = false;
  let scrollY = 0;

  if (!storySection || !texts.length) return;

  /* ---------- MOBILE ---------- */
  if (isMobile) {
    texts.forEach((text, i) => {
      if (!images[i]) return;
      const img = images[i].cloneNode(true);
      img.style.opacity = "1";
      img.style.position = "relative";
      img.style.width = "100%";
      img.style.marginBottom = "16px";
      text.prepend(img);
    });
    return;
  }

  /* ---------- STORY OBSERVER (GIỮ NGUYÊN) ---------- */
  const itemObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const index = texts.indexOf(entry.target);
        currentIndex = index;

        texts.forEach(t => t.classList.remove("is-active"));
        entry.target.classList.add("is-active");

        images.forEach(img => img.classList.remove("active"));
        images[index]?.classList.add("active");

        if (numberEl) numberEl.textContent = index + 1;
      });
    },
    {
      root: storyContainer,
      threshold: 0.3,
      rootMargin: "-20% 0px -30% 0px",
    }
  );

  texts.forEach(text => itemObserver.observe(text));

  /* ---------- LOCK BODY KHI STORY Ở GIỮA ---------- */
  // window.addEventListener("scroll", () => {
  //   if (isLocked) return;

  //   const rect = storySection2.getBoundingClientRect();
  //   const vh = window.innerHeight;

  //   const isCenter =
  //     rect.top < vh * 0.2;

  //   if (isCenter) lockBody();
  // });

  // /* ---------- WHEEL CONTROL ---------- */
  //  window.addEventListener(
  //   "wheel",
  //   (e) => {
  //     const rect = storySection2.getBoundingClientRect();
  //     const atStoryTop = rect.top <= 0;

  //     // Chưa tới story → body scroll bình thường
  //     if (!atStoryTop && !isLocked) return;

  //     // Story vừa chạm TOP → LOCK BODY
  //     if (!isLocked && atStoryTop) {
  //       lockBody();
  //       return;
  //     }

  //     // Chưa lock thì thôi
  //     if (!isLocked) return;

  //     // ĐÃ LOCK → scroll story
  //     e.preventDefault();
  //     storyList.scrollTop += e.deltaY;

  //     // ✅ CHỈ MỞ KHI ITEM CUỐI
  //     if (currentIndex == texts.length - 1) {
  //       unlockBody();
  //     }
  //   },
  //   { passive: false }
  // );


  // /* ---------- BODY LOCK ---------- */
  // function lockBody() {
  //   if (isLocked) return;

  //   scrollY = window.scrollY;
  // document.documentElement.style.scrollBehavior = "auto";
  //   document.body.style.position = "fixed";
  //   document.body.style.top = `-${scrollY}px`;
  //   document.body.style.width = "100%";

  //   isLocked = true;
  // }

  // function unlockBody() {
  //   if (!isLocked) return;

  //   document.body.style.position = "";
  //   document.body.style.top = "";
  //   document.body.style.width = "";

  //   window.scrollTo(0, scrollY);
  //   isLocked = false;
  // }
});
